import { LegalPageLayout } from "../components/LegalPageLayout.tsx";
import { accessibilityDoc } from "../legalDocs.ts";
import legalTranslations from "../legalTranslations.json";

export const Accessibility = ({
  initialLang = "en",
}: {
  initialLang?: "en" | "he";
}) => (
  <LegalPageLayout
    docEn={accessibilityDoc}
    docHe={legalTranslations.accessibility}
    initialLang={initialLang}
  />
);
